import { TextField, Button, Checkbox, Grid, FormControlLabel, CircularProgress } from "@mui/material";
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useRef, useState } from "react";

function CreateSwarmsFilters({filters, setFilters, onSearch, paginationModel, onUnhideEvents}) {
  const [inputs, setInputs] = useState({
    eventName: '',
    eventVenue: '',
    eventDate: '',
    saleDateToday: false,
    onlyActiveSwarms: false,
    onlyFlaggedSwarms: false
  });
  const [isUnhideLoading, setIsUnhideLoading] = useState(false)

  const filtersRef = useRef(inputs);

  useEffect(() => {
    setInputs(filters)
  }, [filters])

  useEffect(() => {
    filtersRef.current = inputs;

    function handleKeyPress(event) {
      if (event.key === 'Enter') {
        console.log('Enter key pressed')
        console.log('filtersRef.current: ', filtersRef.current)
        setFilters(inputs)
        onSearch(filtersRef.current, paginationModel);
      }
    }

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    }

  }, [inputs, setFilters, onSearch, paginationModel]);

  const onUnHideEventsClicked = async () => {
    setIsUnhideLoading(true);
    await onUnhideEvents();
    setIsUnhideLoading(false);
  }

  return (<Grid container spacing={1}>
    <h3 style={{ margin: "0 0 0.5em 0" }} >Events Catalog</h3>
    <Grid container spacing={1} sx={{ display: 'flex' }}>
      <Grid item xs={2}>
        <TextField fullWidth placeholder="Search by Event Name..." value={inputs.eventName} onChange={e => setInputs({ ...inputs, eventName: e.target.value })} />
      </Grid>
      <Grid item xs={2}>
        <TextField fullWidth placeholder="Search by Venue Name..." value={inputs.eventVenue} onChange={e => setInputs({ ...inputs, eventVenue: e.target.value })} />
      </Grid>
      <Grid item >
        <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
          <DatePicker
            disabled={inputs.saleDateToday}
            value={inputs.eventDate && dayjs(inputs.eventDate)} // null as default or a date will be returned and placeholder will not work
            onChange={(e) => setInputs({ ...inputs, eventDate: e?.$d ? e.$d.toISOString() : null })}
            slotProps={{
              textField: { placeholder: "Search by Sale Date...", disabled: true, inputProps: { style: { border: "none" } } },
              actionBar: { actions: ['clear'] }
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item sx={{ display: 'flex' }}>
        <Grid item >
          <Button sx={{ width: '100px', margin: '0 1em 0 0' }} variant="contained" onClick={() => { setFilters(inputs); onSearch(inputs, paginationModel) }}>Search</Button>
        </Grid>
        <Grid item >
          <Button sx={{ width: '100px' }} variant="outlined" onClick={() => setInputs({ eventName: '', eventVenue: '', eventDate: '', saleDateToday: false, onlyActiveSwarms: false })}>Clear</Button>
        </Grid>
      </Grid>
    </Grid>
    <Grid item >
      <FormControlLabel checked={inputs.saleDateToday} onChange={e => setInputs({ ...inputs, saleDateToday: e.target.checked, eventDate: e.target.checked ? null : inputs.eventDate })} control={<Checkbox />} label="Sale date today" />
    </Grid>
    <Grid item >
      <FormControlLabel control={<Checkbox checked={inputs.onlyActiveSwarms} onChange={e => setInputs({ ...inputs, onlyActiveSwarms: e.target.checked })} />} label="Only show active swarms" />
    </Grid>
    <Grid item >
      <FormControlLabel control={<Checkbox checked={inputs.onlyFlaggedSwarms} onChange={e => setInputs({ ...inputs, onlyFlaggedSwarms: e.target.checked })} />} label="Only show flagged swarms" />
    </Grid>
    <Grid item>
      <Button variant="outlined" sx={{height: '30px', width: '170px', whiteSpace: 'nowrap'}} disabled={isUnhideLoading} onClick={onUnHideEventsClicked}>
        {
          isUnhideLoading ? <CircularProgress size="1.5em" color="inherit" /> : "Show hidden events"
        }
      </Button>
    </Grid>
  </Grid>)
};

export default CreateSwarmsFilters;
